import API from '@/api'
import prepareCommentsToTable from '@/utils/table/prepareCommentsToTable'
import router from '@/router'

export const moduleName = 'comments'

export const actionTypes = {
  ACTION_LOAD_COMMENTS: 'ACTION_LOAD_COMMENTS',
  ACTION_INIT_WS: 'ACTION_INIT_WS',
  ACTION_JOIN_TO_COMMENTS: 'ACTION_JOIN_TO_COMMENTS',
  ACTION_DELETE_COMMENTS: 'ACTION_DELETE_COMMENTS',
  ACTION_EDIT_COMMENT: 'ACTION_EDIT_COMMENT'
}

export const getterTypes = {
  GETTER_COMMENTS: 'GETTER_COMMENTS',
  GETTER_COMMENTS_COUNT: 'GETTER_COMMENTS_COUNT'
}

export const mutationTypes = {
  MUTATION_SET_COMMENTS: 'MUTATION_SET_COMMENTS',
  MUTATION_SET_COMMENTS_COUNT: 'MUTATION_SET_COMMENTS_COUNT',
  MUTATION_ADD_COMMENT: 'MUTATION_ADD_COMMENT',
  MUTATION_DELETE_COMMENT: 'MUTATION_DELETE_COMMENT',
  MUTATION_UPDATE_COMMENT: 'MUTATION_UPDATE_COMMENT',
  MUTATION_EDIT_COMMENT: 'MUTATION_EDIT_COMMENT',
  MUTATION_UPDATE_USER_COMMENT: 'MUTATION_UPDATE_USER_COMMENT',
}

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    comments: [],
    commentsCount: 0
  }),

  actions: {
    [actionTypes.ACTION_INIT_WS] ({ commit, rootState }) {
      const onDeleteComment = ({ value }) => {
        commit(mutationTypes.MUTATION_DELETE_COMMENT, value)
      }

      const onAddComment = ({ value }) => {
        commit(mutationTypes.MUTATION_ADD_COMMENT, value.comment)
      }

      const onUpdateComment = ({ value }) => {
        commit(mutationTypes.MUTATION_UPDATE_COMMENT, value.comment)
      }

      const onEditComment = ({ value }) => {
        commit(mutationTypes.MUTATION_EDIT_COMMENT, value)
      }
      
      const onUpdate = ({ value }) => {
        commit(mutationTypes.MUTATION_UPDATE_USER_COMMENT, value)
      }

      API.comments.wsListeners[API.comments.wsEvents.COMMENT_ADD](onAddComment)
      API.comments.wsListeners[API.comments.wsEvents.COMMENT_UPDATE](onUpdateComment)
      API.comments.wsListeners[API.comments.wsEvents.COMMENT_DELETE](onDeleteComment)
      API.comments.wsListeners[API.comments.wsEvents.USER_MANAGER_EDIT_COMMENT](onEditComment)
      API.comments.wsListeners[API.comments.wsEvents.USER_MANAGER_UPDATE_COMMENT](onUpdate)
    },

    [actionTypes.ACTION_JOIN_TO_COMMENTS] () {
      API.comments.wsActions.ACTION_JOIN_TO_COMMENTS()
    },

    async [actionTypes.ACTION_LOAD_COMMENTS] ({ commit }, payload) {
      const { data: res } = await API.comments.loadComments(payload)
      commit(mutationTypes.MUTATION_SET_COMMENTS, res.comments)
      commit(mutationTypes.MUTATION_SET_COMMENTS_COUNT, res.count)
    },

    [actionTypes.ACTION_DELETE_COMMENTS] ({}, payload) {
      API.comments.wsActions.ACTION_DELETE_COMMENTS(payload)
    },

    [actionTypes.ACTION_EDIT_COMMENT] (_, payload) {
      API.comments.wsActions.ACTION_EDIT_COMMENT(payload)
    }
  },

  mutations: {
    [mutationTypes.MUTATION_SET_COMMENTS] (state, comments) {
      state.comments = comments
    },
    [mutationTypes.MUTATION_SET_COMMENTS_COUNT] (state, count) {
      state.commentsCount = count
    },
    [mutationTypes.MUTATION_EDIT_COMMENT] (state, comment) {
      state.comments = state.comments.map(c => {
        if (c.id === comment.id) {
          c.comment = comment.comment
        }
        return c
      })
    },
    [mutationTypes.MUTATION_UPDATE_USER_COMMENT] (state, comment) {
      const commentIndex = state.comments.findIndex(c => c.id === comment.id)
      if (commentIndex >= 0) {
        state.comments.splice(commentIndex, 1, comment)
      } 
    },
    [mutationTypes.MUTATION_ADD_COMMENT](state, comment) {
      if (state.comments.some(c => c.id === comment.id)) return
      const maxComments = Number(router.currentRoute.query.take) || 10

      state.comments.unshift(comment)
      if (state.comments.length > maxComments) {
        state.comments.pop()
      }
    },
    [mutationTypes.MUTATION_UPDATE_COMMENT](state, comment) {
      const commentIndex = state.comments.findIndex(c => c.id === comment.id)
      if (commentIndex >= 0) {
        state.comments.splice(commentIndex, 1, {
          ...state.comments[commentIndex],
          ...comment
        })
      }
    },
    [mutationTypes.MUTATION_DELETE_COMMENT] (state, { deletedComments, appendedComments, commentsCount }) {
      if (Array.isArray(deletedComments) && Array.isArray(appendedComments)) {
        deletedComments.forEach(deletedComment => {
          const userIndex = state.comments.findIndex(u => u.id === deletedComment.id)
          if (userIndex >= 0) {
            state.comments.splice(userIndex, 1)
          }
        })

        state.comments.push(...appendedComments)
        state.commentsCount = commentsCount
      }
    },
  },

  getters: {
    [getterTypes.GETTER_COMMENTS]: (state) => prepareCommentsToTable(state.comments),
    [getterTypes.GETTER_COMMENTS_COUNT]: (state) => state.commentsCount
  }
}
